import { routerFor, routerForUrl } from "../../common/other";
import configData from "../../config/config";
import recursionRouter from "../../router/add-router";
import router from "../../router/index";
import { getPermission } from "../../api/api-basic";
import { piUtGetStorage } from "@/utils/utils";
import { piUtDebounce } from "@/utils/utils";
const state = {
    isLogin: false,
    winOnresize: false,
    isGetRouter: false,
    keepAliveList: [],
    goRouter: [],
    goRouterList: [],
    toData: {},
    routerList: [],
    routerMainIndex: {},
    userInfo: {},
    userType: "user",
    menuIndex: 0,
    menuList: [],
    pageLoading: false,
    operInfo: {},
};
const getters = {};
const mutations = {
    /**
     * 是否登录
     * @param state
     * @param status 状态
     */
    SET_ISLOGIN(state, status) {
        state.isLogin = status;
    },
    /**
     * 窗口变化是改变
     * @param state
     */
    SET_WINONRESIZE(state) {
        state.winOnresize = !state.winOnresize;
    },
    /**
     * 动态添加路由
     * @param {*} state
     * @param {objAny[]} list 后台返回的菜单
     */
    SET_ROUTERLIST(state, list) {
        const routerList = recursionRouter(list); // eslint-disable-line
        //动态添加路由
        router.addRoutes(routerList);
        state.routerList = routerList;
    },
    /**
     * 路由变化时执行,保存经过的路由,最多5个,用在tag标签和缓存路由
     * @param {*} state
     * @param {objAny} data 经过路由的数据
     */
    SET_GOROUTER(state, data) {
        let isPush = true;
        state.goRouter.map((item) => {
            if (item.url == data.url) {
                item.fullPath = data.fullPath;
                isPush = false;
            }
        });
        if (isPush) {
            if (state.goRouter.length >= 9) {
                state.goRouter.splice(0, 1);
                state.keepAliveList.splice(0, 1);
            }
            state.goRouter.push(data);
            state.keepAliveList.push(data.componentsName);
        }
        state.goRouterList.push(data);
        if (state.goRouterList.length >= 9) {
            state.goRouterList.splice(0, 1);
        }
        // if (data.mainIdex) {
        //   let isPush = true;
        //   state.goRouter.map((item: objAny) => {
        //     if (item.url == data.url) {
        //       isPush = false;
        //     }
        //   });
        //   if (isPush) {
        //     if (state.goRouter.length >= 6) {
        //       state.goRouter.splice(0, 1);
        //     }
        //     state.goRouter.push(data);
        //   }
        // }
    },
    /**
     *  删除路由 tag
     * @param {*} state
     * @param {number} index
     */
    UP_GOROUTER(state, index) {
        // const list = state.goRouter;
        // list.splice(index, 1);
        // state.goRouter = list;
        // const keepAliveList: objAny[] = [];
        // list.map((item: objAny) => {
        //   keepAliveList.push(item.componentsName);
        // });
        // state.keepAliveList = keepAliveList;
        state.goRouter.splice(index, 1);
        state.keepAliveList.splice(index, 1);
    },
    /**
     * 根据URL删除路由
     * @param {*} state
     * @param {string} url
     */
    urlRemoveRouter(state, url) {
        let index = -1;
        state.goRouter.map((item, i) => {
            if (item.url == url) {
                index = i;
            }
        });
        if (index != -1) {
            state.goRouter.splice(index, 1);
            state.keepAliveList.splice(index, 1);
        }
    },
    /**
     * 当前的路由
     * @param {*} state
     * @param {objAny} data
     */
    SET_TODATE(state, data) {
        state.toData = data;
    },
    /*
     * 是否经过路由初始化
     * @param {*} state
     * @param {boolean} status
     */
    SET_ISGETROUTER(state, status) {
        state.isGetRouter = status;
    },
    /**
     * 登录信息
     * @param {*} state
     * @param {objAny} data
     */
    SET_USERINFO(state, data) {
        state.userInfo = data;
        if (data.roleType == 4) {
            state.userType = "mchAdmin";
        }
        else {
            // data.roleType == 8
            state.userType = "mchUser";
        }
    },
    /**
     * 登录信息
     * @param {*} state
     * @param {objAny} data
     */
    SET_MENULIST(state, list) {
        state.menuList = routerFor(list);
    },
    SET_PAGELOADING(state, status) {
        state.pageLoading = status;
    },
    SET_OPERINFO(state, data) {
        state.operInfo = data;
    },
};
const forMenuChild = function (list) {
    let str = "";
    list.map((item, index) => {
        if (index == 0) {
            if (item.children && item.children.length > 0) {
                str = forMenuChild(item.children);
            }
            else {
                str = item.url;
            }
        }
    });
    return str;
};
const actions = {
    /**
     * 路由初始化
     * @param {*} { commit, state }
     * @param {objAny} obj
     */
    async getRouter({ commit }, obj) {
        const loginData = piUtGetStorage("loginData");
        const win = window;
        if (loginData) {
            state.isGetRouter = true;
            commit("SET_USERINFO", loginData);
            // commit("SET_MENULIST", menuListData);
            // commit("SET_ROUTERLIST", menuListData);
            let toUrl = obj.to.fullPath;
            const retMemu = await getPermission({ roleId: loginData.rolePkId });
            if (retMemu.status === configData.apiStatus) {
                let listObj = {};
                retMemu.data.map((item) => {
                    if (item.modulePkId == configData.sysModulePkId) {
                        listObj = item;
                    }
                });
                const data = listObj.children ? listObj.children : [];
                // 登录进来，首页还没有做的时候
                commit("SET_MENULIST", data);
                commit("SET_ROUTERLIST", data);
                if (toUrl == "/") {
                    const itemDataUrl = routerForUrl(data);
                    if (itemDataUrl) {
                        toUrl = itemDataUrl.url;
                    }
                    else {
                        toUrl = forMenuChild(data);
                    }
                }
            }
            commit("SET_ISLOGIN", true);
            // const ret = await getOprInfo({});
            // if (ret.status === configData.apiStatus) {
            //   // operInfo
            //   const info = ret.data[0] || {};
            //   commit("SET_OPERINFO", info);
            // }
            obj.next &&
                obj.next({
                    path: toUrl,
                });
        }
        else {
            commit("SET_ISGETROUTER", false);
            commit("SET_ISLOGIN", false);
            if (configData.loginUrl && configData.loginUrl != "") {
                win.location.href = configData.loginUrl;
            }
            else {
                obj.next({
                    path: "/login",
                });
            }
        }
        win.onresize = piUtDebounce(() => {
            commit("SET_WINONRESIZE", true);
        }, 200);
    },
};
export default {
    state,
    mutations,
    actions,
    getters,
};
